import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretUpMdLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.97982 9.68656C5.17508 9.88182 5.49167 9.88182 5.68693 9.68656L8.00004 7.37348L10.3132 9.68656C10.5084 9.88182 10.825 9.88182 11.0202 9.68656C11.2155 9.4913 11.2155 9.17474 11.0202 8.97948L8.35357 6.31281C8.15831 6.11755 7.84177 6.11755 7.64651 6.31281L4.97982 8.97948C4.78456 9.17474 4.78456 9.4913 4.97982 9.68656Z",
		fill: "currentColor"
	})
});
export default SvgCaretUpMdLine;
